import { currentUser } from "./user";
import { app } from "../firebase";
import { writable } from "svelte/store";

let lastUser;

const storage = app.storage().ref();

export const assets = writable(null);

currentUser.subscribe(async (user) => {
    if (!user) return emptyAssets();
    if (user.email === (lastUser && lastUser.email) || !user.active) return;
    lastUser = user;
    await fetchAssets(user);
});

function emptyAssets() {
    lastUser = null;
    assets.set(null);
}

export async function fetchAssets() {
    const { items } = await storage.list();
    assets.set(
        await Promise.all(
            items.map(async (item) => ({
                name: item.name,
                fullPath: item.fullPath,
                metadata: await item.getMetadata(),
            }))
        )
    );
}

export function uploadAsset(asset) {
    return storage.child(asset.name).put(asset);
}

export function deleteAsset(asset) {
    return storage.child(asset).delete();
}
